'use strict';

requirejs.config({
  baseUrl: '/public/static/dist',
  // 由 fis 管理，并在 /inc/script.ejs 上注入
  // 日常维护配置，编辑 global/requirejs_paths.json
  // paths: {},
  skipDataMain: true,
  debug: true
});

/* eslint-disable no-eval, quotes */
// vendor 系列，不由 requirejs 加载，额外绕过
eval('define(\'jquery\', function () { return window.$; })');
eval('define(\'lodash\', function () { return window._; })');
/* eslint-enable */